import React, { useState } from 'react'
import c from 'classnames'
import { connect } from 'react-redux'
import isEqual from 'lodash/isEqual'
import flatten from 'lodash/flatten'

import Tag from 'discada/dist/Tag'
import Button from 'discada/dist/Button'
import Icon from 'discada/dist/Icon'
import { CheckboxField } from 'discada/dist/Form'

import { ReactionSection } from 'components/widgets/Reactions/ReactionSection'

import { toggleRebateCategory } from 'actions/quoteActions'
import { getQuoteValue, getRebateCount } from 'selectors/quoteSelectors'

import rebateCategories from 'components/Quote/rebateCategories'

import { tagCustomer } from 'actions/appStatusActions'
import { getCustomerHasNoRebates } from 'selectors/naughtySelectors'
import { getQueryValue, getParamValue } from 'selectors/pageStateSelectors'

import './SimpleRebates.scss'

export function SimpleRebates(props) {
  let {
      className,
      vehicleId,
      quoteId,
      selectedCategories = [],
      showAll,
      showSubcategories,
      size = 'small',
      rounded = true,
      noRebates,
      tagCustomer = () => {},
      tag = true,
      onChange = () => {},
      getCount = () => showAll,
      toggleRebateCategory = () => {},
    } = props,
    [showAllSubs, setShowAllSubs] = useState(showSubcategories),
    isChecked = (cat, parent = null) =>
      selectedCategories.some(rc => {
        let testCat = { ...cat }

        if (parent) testCat.parent = parent

        return (
          isEqual(rc.ID, testCat.ID) &&
          isEqual(rc.Name, testCat.Name) &&
          isEqual(rc.Subcategory, testCat.Subcategory)
        )
      })

  const makeButtons = (categories, parent) => {
    return flatten(
      categories.map(rc => {
        let count = getCount({ ...rc, parent }),
          checked = isChecked(rc, parent)

        return rc.Subcategory ? (
          showAllSubs ? (
            makeButtons(rc.Subcategory, rc)
          ) : null
        ) : count || showAll ? (
          <Tag
            size={size}
            rounded={rounded}
            key={rc.Name}
            color={checked ? 'success' : null}
            onClick={() => {
              onChange(rc, checked, parent)
              toggleRebateCategory(vehicleId, quoteId, rc, parent, tag)
            }}
          >
            <Icon icon={checked ? 'check' : 'plus'} /> {rc.Name}
          </Tag>
        ) : null
      }),
    ).filter(x => x)
  }

  let buttons = makeButtons(rebateCategories),
    setNoRebates = () => {
      let hasNoRebates = !noRebates

      tagCustomer(vehicleId, quoteId, true, {
        hasNoRebates,
      })
    }

  return (
    <ReactionSection
      className={c('rebates-reaction-section', 'simple-rebates', className)}
      title={
        <>
          <span role="img" aria-label="appraisal">
            💵
          </span>
          Get Extra Savings!
        </>
      }
      explainer={
        <span>
          Extra <strong>INCENTIVES</strong> help lower your overall price and
          payments. Select all that apply then click See <strong>YOUR</strong>{' '}
          Payments!
        </span>
      }
    >
      <div className="switch-wrapper">{buttons}</div>
      <Button
        text
        tabIndex="-1"
        size="small"
        onClick={() => setShowAllSubs(!showAllSubs)}
        className="toggle-all-subs"
      >
        toggle all categories
      </Button>

      <CheckboxField
        size="small"
        className="no-rebates-control"
        label="I don't qualify for any of these"
        checked={noRebates}
        onClick={setNoRebates}
      />
    </ReactionSection>
  )
}

function mapStateToProps(state, op) {
  return {
    ...op,
    vehicleId: op.vehicleId || getParamValue(state, 'id'),
    quoteId: op.quoteId || getQueryValue(state, 'quoteId'),
    noRebates: op.hasNoRebates || getCustomerHasNoRebates(state),
    getCount: cat => getRebateCount(state, op.vehicleId, op.quoteId, cat),
    selectedCategories:
      op.selectedCategories ||
      getQuoteValue(
        state,
        op.vehicleId,
        op.quoteId,
        'selectedRebateCategories',
        [],
      ),
  }
}

export default connect(
  mapStateToProps,
  { toggleRebateCategory, tagCustomer },
)(SimpleRebates)
